import { getInsuranceFunction } from '@/common/queries/selections/insurance/insuranceFunction';
import { queryOptions } from '@tanstack/react-query';

export const insuranceOption = ({ name }: { name: string | null }) =>
  queryOptions({
    queryKey: ['get_insurances', name],
    queryFn: () => getInsuranceFunction({ name }),
  });
